import { TeamRoleFilterEnum } from '../enums/team-role-filter.enum';
import { ITeamRoleFilterOption } from '../interfaces/team-role-filter-option.interface';

export class TeamRoleFilterOptions {
    static readonly defaultRoleIds: TeamRoleFilterEnum[] = [
        TeamRoleFilterEnum.TeamLeader,
        TeamRoleFilterEnum.TrainingResponsible,
        TeamRoleFilterEnum.TeamMember,
    ];

    static createDefaultOptions(): ITeamRoleFilterOption[] {
        return [
            {
                id: TeamRoleFilterEnum.TeamLeader,
                translationKey: 'GENERAL.LABEL.TEAM_LEADER',
                selected: true,
            },
            {
                id: TeamRoleFilterEnum.TrainingResponsible,
                translationKey: 'TEAMS.TRAINING_RESPONSIBLE.TITLE',
                selected: true,
            },
            {
                id: TeamRoleFilterEnum.TeamMember,
                translationKey: 'GENERAL.LABEL.TEAM_MEMBER',
                selected: true,
            },
        ];
    }
}
